<template>
  <div class="flex">
    <div class="container" v-for="(item,index) in list" :key="index" @click="detail(index,item)">
      <div><img :src="item.img" alt="" /></div>
      <span>{{item.name}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    list:{
      type:Array,
      default:[]
    },
  },
  data() {
    return {};
  },
  methods:{
    detail(index,item){
      this.$emit('detail',{index,item})
    }
  },
};
</script>

<style lang="scss" scoped>
.flex{
  display: flex;
  flex-wrap: wrap;
}
.container:hover{
  box-shadow: 0 0.188679rem 0.113208rem 0 #d8e2eb;
}
.container {
  // margin: 0 40px;
  margin-right: 14px;
  margin-bottom: 14px;
  width: 288px;
  height: 216px;
  padding: 9px;
  // border: 1px solid red;
  border-radius: 10px;
  background: #fff;
  > div {
    width: 288px;
    height: 180px;
    img {
      display: block;
      width: 100%;
      height: 180px;
    }
  }
  > span {
    margin-top: 14px;
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/caozuoshouce/vidoe.vue